<template>
  <div class="tab_box">
    <!-- 错误的表格-->
    <!-- <el-button type="text" @click="dialogTableVisible = true">打开嵌套表格的 Dialog</el-button> -->
    <!-- <el-dialog title="错误的上传数据" :visible.sync="isExcelError" width="900px">
      <tab-list :tabList="excelErrorList" :columns="excelErrorTabColumns" isno nheight="400">
      </tab-list>
    </el-dialog>-->

    <!-- 可编辑的表格 -->
    <vxe-table
      border
      resizable
      show-overflow
      ref="editTabList"
      :data="selectedMatterSaleSend"
      :edit-config="{trigger: 'click', mode: 'cell',activeMethod: activeCellMethod}"
      @edit-disabled="editDisabledEvent" 
    >
      <vxe-table-column type="checkbox" width="40"></vxe-table-column>
      <vxe-table-column field="materialCode" title="物料编码"></vxe-table-column>
      <vxe-table-column field="materialDesc" title="物料描述"></vxe-table-column>
      <vxe-table-column field="targetNum" title="订单数量"></vxe-table-column>
      <vxe-table-column field="kbmeng" title="剩余数量"></vxe-table-column>
      <vxe-table-column field="currentDeliveryNum" title="发货数量" :edit-render="{name: 'input', attrs: {type: 'number'}}"></vxe-table-column>
      <vxe-table-column field="targetUnitDesc" title="计量单位"></vxe-table-column>
      <vxe-table-column
        field="factoryDesc"
        title="工厂描述"
      ></vxe-table-column>
      <vxe-table-column
        field="inventoryDesc" 
        title="库存地点"
      ></vxe-table-column>
      <vxe-table-column
        field="batchNo"
        title="批次号"
      ></vxe-table-column>
      <vxe-table-column field="materialGroup" title="物料组"></vxe-table-column>
      <vxe-table-column field="netPrice" title="销售单价"></vxe-table-column>
      <vxe-table-column field="taxm1" title="销项税(%)"></vxe-table-column>
    </vxe-table>
  </div>
</template>
<script>
import editTabList from "components/table/vxeTab.vue";

import { mapState, mapActions } from "vuex";
export default {
  components: {
    editTabList
  },
  props: {
    fromData: Object,
    noFromData: Object
  },
  computed: {
    ...mapState("cache", ["selectedMatterSaleSend"])
  },
  data() {
    return {
      PurchOrderList: []
    };
  },
  created() {},
  mounted: function() {},
  updated: function() {}, 
  methods: {
    ...mapActions("cache", ["setSelectedSaleSendMaterial"]),
    activeCellMethod({ column, columnIndex }) {
      if (columnIndex === 5) {
        return true;
      } 
      return false;
    },
    editDisabledEvent({ row, column }) {
      // this.$message.error("禁止编辑");
    },
    onSubmitSaves(){
            this.PurchOrderList = this.$refs.editTabList.getCheckboxRecords();
            // console.log(this.PurchOrderList,'== 444 ==');
    }
  }
};
</script>

<style>
</style>
